/* ---------- 12. lite-youtube: accept a full YouTube URL in videoid ---------- */

import { $$ } from '../lib/dom';

// watch?v=ID · youtu.be/ID · /embed/ID · /shorts/ID · /live/ID · /v/ID — IDs are 11 URL-safe chars
const YT_ID = /(?:youtu\.be\/|\/(?:embed|shorts|live|v)\/|[?&]v=)([\w-]{11})/;

/** CMS fields hold the share/embed URL; `<lite-youtube>` wants the bare ID. Rewrites `videoid` before lite-yt-embed
 *  upgrades the element; if it already did (script order), patches its `videoId` + poster too. Bare IDs pass through. */
export const liteYoutube = () =>
  $$('lite-youtube[videoid]').forEach((el) => {
    const id = YT_ID.exec(el.getAttribute('videoid') ?? '')?.[1];
    if (!id) return;
    el.setAttribute('videoid', id);
    if (!('videoId' in el)) return;
    Object.assign(el, { videoId: id });
    el.style.backgroundImage = `url("https://i.ytimg.com/vi/${id}/hqdefault.jpg")`;
  });
